/**
 * Live feedback, computed from the trees and the counts alone (CLAUDE.md §10): the answer key
 * never reaches this code. Only what can no longer be right is flagged.
 */
import type { Feedback } from "../types";
import { resizeRows } from "./progress";
import { contradictions } from "./rules";
import { cellId, type TentsDefinition, type TentsProgress } from "./types";

const cellsOfKeys = (keys: Set<string>): string[] =>
  [...keys].map((k) => {
    const [r, c] = k.split(",").map(Number);
    return cellId(r, c);
  });

export function localFeedback(definition: TentsDefinition, progress: TentsProgress): Feedback[] {
  const marks = resizeRows(progress.rows, definition.rows, definition.cols);
  const found = contradictions(definition.trees, definition.counts, marks);
  const feedback: Feedback[] = [];
  if (found.tents.size > 0)
    feedback.push({ type: "tent", code: "tent_misplaced", cells: cellsOfKeys(found.tents) });
  if (found.trees.size > 0)
    feedback.push({ type: "tree", code: "tree_fenced_in", cells: cellsOfKeys(found.trees) });
  for (const line of found.lines) {
    const [axis, raw] = line.split(":");
    const index = Number(raw);
    feedback.push({
      type: axis,
      code: "count_contradiction",
      index,
      cells:
        axis === "row"
          ? Array.from({ length: definition.cols }, (_, c) => cellId(index, c))
          : Array.from({ length: definition.rows }, (_, r) => cellId(r, index)),
    });
  }
  return feedback;
}
